<template>
  <CRow>
    <CCol sm="12">

      <CCard v-if="hersteller">

        <CCardHeader>
          <CRow>
            <CCol sm="8">
              <CIcon name="cil-text"/>
              <h5>Übersicht über alle Hersteller</h5>
            </CCol>
            <CCol sm="4" class="text-right">
              <CButton color="success" size="sm" v-on:click="newEntry"><CIcon name="cil-library-add"/> Neuer Hersteller</CButton>
            </CCol>
          </CRow>
        </CCardHeader>

        <CCardBody>

          <CDataTable
            :items="computedItems"
            :fields="fields"
            hover
            :items-per-page-select="{label: 'Einträge pro Seite'}"
            :items-per-page="25"
            column-filter
            sorter
            pagination
          >
            <template #no-items-view><NoData/></template>

            <template #actionbar="{item}">
              <td nowrap="" width="1%">
                <CButton
                  color="primary"
                  variant="outline"
                  square
                  size="sm"
                  v-c-tooltip="{content: 'Editieren', placement:'left'}"
                  v-on:click="editEntry(item.herstellerid)"
                >
                  <CIcon name="cil-highlighter"/>
                </CButton>
                <CButton
                  color="danger"
                  variant="outline"
                  size="sm"
                  class="ml-2"
                  v-c-tooltip="{content: 'Löschen', placement:'left'}"
                  v-on:click="deleteEntry(item.herstellerid)"
                >
                  <CIcon name="cil-trash"/>
                </CButton>
              </td>
            </template>

          </CDataTable>

        </CCardBody>

      </CCard>

    </CCol>
  </CRow>
</template>

<script>
import Vue from 'vue'
import NoData from '@/components/NoData'

export default {
  name: 'HerstellerIndex',
  components: {
    NoData
  },
  data () {
    return {
      hersteller: [],
      fields: [
        {
          key: 'herstellerid',
          label: 'ID'
        },
        {
          key: 'herstellernr',
          label: 'Hersteller Nummer'
        },
        {
          key: 'hersteller',
          label: 'Name'
        },
        {
          key: 'actionbar',
          label: '',
          _style: 'width:1%',
          sorter: false,
          filter: false
        }
      ]
    }
  },
  computed: {
    computedItems () {
      if (this.hersteller) {
        if (this.hersteller.length > 0) {
          return this.hersteller.map(hersteller => {
            const result = {
              herstellerid: hersteller.herstellerid ? hersteller.herstellerid : '',
              herstellernr: hersteller.herstellernr ? hersteller.herstellernr : '',
              hersteller: hersteller.hersteller
            }

            return result
          })
        } else {
          return []
        }
      } else {
        return []
      }
    }
  },
  mounted () {
    this.loadHersteller()
  },
  methods: {
    newEntry () {
      this.$router.push({ path: '/hersteller/neu' })
    },
    loadHersteller () {
      Vue.axios.get('/hersteller/get')
        .then((response) => {
          this.hersteller = response.data
        })
    },
    editEntry (herstellerid) {
      this.$router.push({ path: `/hersteller/editieren/${herstellerid}` })
    },
    deleteEntry: function (herstellerid) {
      const self = this
      const options = {
        okText: 'Ja',
        cancelText: 'Nein'
      }
      this.$dialog
        .confirm('Den hersteller wirklich löschen?', options)
        .then((dialog) => {
          Vue.axios.delete('/hersteller/delete/' + herstellerid)
            .then((response) => {
              self.$snotify.error('Der hersteller wurde gelöscht.', {
                position: 'rightTop',
                timeout: 4000
              })
              this.loadHersteller()
            })
        })
        .catch(() => {
          // Do Nothing
        })
    }
  }
}
</script>
